export default "__VITE_ASSET__53696f5e__"